import React, { useState, useEffect } from 'react';
import { Typography, Collapse } from 'antd';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import { trace } from '../../../components/tagmanager';
import { useParams, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAnalytics, logEvent } from 'firebase/analytics';
import axios from 'axios';
import env from '../../../environment';
import tagSabadell from '../../../components/tagSabadell';
import i18n from '../../../i18n';
import OffersWidgets from '../Offers/OffersWidgets';
import AppraisalWidget from './AppraisalAndFormalizationWidget';

const { Text } = Typography;
const { Panel } = Collapse;

const Appraisal = ({
	stages,
	dataMortgage,
	userMortgageId,
	openCollapse,
	setOpenCollapse,
	handleChangeCollapse,
	docsNumber
}) => {
	const operations = useSelector((state) => state.auth.operations);
	const { operationId, stage } = useParams();
	const nameOperations =
		operations !== undefined &&
		operations.find((operation) => operation.operationId === operationId);
	const rol = useSelector((state) => state.auth.roles);
	const location = useLocation();
	const userToken = useSelector((state) => state.auth.token);
	const analytics = getAnalytics();
	const [existAppraisal, setExistAppraisal] = useState(undefined);

	const { t } = useTranslation();

	useEffect(() => {
		trace({
			location,
			userToken,
			rol,
			stage: 'appraisal',
			operationName: nameOperations && nameOperations.name
		});
		logEvent(analytics, 'screen_view', {
			screen_name: 'm.component.appraisal'
		});
		tagSabadell('tasacion', i18n.language === 'cat' ? 'ca' : 'es');
	}, []);

	useEffect(() => {
		getAppraisal();
	}, [stages]);

	const getAppraisal = () => {
		axios
			.get(`${env.api.url}/v1/documents/get-operation-documents/${userMortgageId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setExistAppraisal(response.data.data.find((value) => value.type === 'appraisal'));
			})
			.catch(() => {
				undefined;
			});
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column'
			}}>
			<OffersWidgets
				openCollapse={openCollapse}
				setOpenCollapse={setOpenCollapse}
				handleChangeCollapse={handleChangeCollapse}
				docsNumber={docsNumber}
			/>
			<div
				style={{
					backgroundColor: '#fff',
					display: 'flex',
					justifyContent: 'center',
					marginTop: isMobileOnly ? 8 : 16,
					borderRadius: 4
				}}>
				<Collapse
					accordion
					style={{ width: isMobileOnly ? '100%' : 'calc(100% - 48px)', border: 'none' }}
					className={`collapse-doc ${!openCollapse[3] ? 'collapse-doc-close' : ''} ${
						isMobileOnly ? 'collapse-doc-mobile' : ''
					}`}
					defaultActiveKey={
						stage === 'appraisal' ||
						stage === 'formalization' ||
						stage === 'documents' ||
						stage === 'analysis'
							? undefined
							: ['1']
					}
					activeKey={openCollapse[3] ? ['1'] : undefined}
					onChange={() => handleChangeCollapse('3')}
					expandIconPosition={'end'}>
					<Panel
						header={
							<div style={{ width: '100%' }} tabIndex={0} className="tab-focus">
								<Text>
									{process.env.REACT_APP_BRAND === 'office'
										? t('formalization.titlteOffice')
										: t('finish.steps')}
								</Text>
							</div>
						}
						key="1">
						<AppraisalWidget
							handleChangeCollapse={handleChangeCollapse}
							dataMortgage={dataMortgage}
							operationId={userMortgageId}
							stages={stages}
							existAppraisal={existAppraisal}
							getAppraisal={getAppraisal}
							docsNumber={docsNumber}
						/>
					</Panel>
				</Collapse>
			</div>
		</div>
	);
};

export default Appraisal;
